// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'issued-loan.page.title': 'Issued Loans',
    'issued-loan.page.repaid.title': 'Repaid Loans',
    'issued-loan.page.search_results': 'Search Results',
    'issued-loan.page.create.title': 'Issue New Loan',
    'issued-loan.page.search.title': 'Find Loans',
    'issued-loan.page.edit.title': 'Edit Loan',
    'issued-loan.page.view.title': 'View Loan',
    'issued-loan.page.all': 'All',

    'issued-loan.button.cancel': 'Cancel',
    'issued-loan.button.select': 'Select',
    'issued-loan.button.find': 'Find Loans',
    'issued-loan.button.search': 'Apply',
    'issued-loan.button.create': 'Create Loan',
    'issued-loan.button.new': 'New Loan',
    'issued-loan.button.save': 'Save Changes',
    'issued-loan.button.repaid': 'Mark Repaid',
    'issued-loan.button.edit': 'Edit',
    'issued-loan.button.restore': 'Restore',
    'issued-loan.button.reset': 'Reset',
    'issued-loan.button.rollback': 'Rollback Loan',
    'issued-loan.button.void': 'Void Loan',
    'issued-loan.button.draft': 'Save Draft',
    'issued-loan.button.cancel_draft': 'Cancel Draft',
    'issued-loan.button.record_payment': 'Record Repayment',
    'issued-loan.button.collaterals': 'Collaterals',

    'issued-loan.placeholder.search': 'Search issued loans',

    'issued-loan.link.create_first_issued_loan': 'Click here to create your first loan',
    'issued-loan.link.issued_loans': ' Return to Issued Loans',
    'issued-loan.link.repaid': 'Repaid Loans',
    'issued-loan.link.retry': 'Click here to retry',

    'issued-loan.checkbox.all': 'Check All',
    'issued-loan.checkbox.actions_label': 'with selected',

    'issued-loan.label.is_team_member': 'Is Team Member',
    'issued-loan.label.entity_name': 'Borrower',
    'issued-loan.label.loan_date': 'Loan Date',
    'issued-loan.label.from_date': 'From Date',
    'issued-loan.label.thru_date': 'Thru Date',
    'issued-loan.label.duration': 'Duration',
    'issued-loan.label.months': 'month|months',
    'issued-loan.label.interest_rate': 'Interest Rate (%)',
    'issued-loan.label.currency_name': 'Currency',
    'issued-loan.label.currency_loan_amount_in_cents': 'Loan Amount',
    'issued-loan.label.currency_balance_owing_in_cents': 'Total Amount Repayable',
    'issued-loan.label.estimated_balance_owing': 'Estimated Balance owing',
    'issued-loan.label.currency_total_repayments_made_in_cents': 'Total Repayments Made',
    'issued-loan.label.bank_general_ledger_account_name': 'Issue Loan from Bank Account',
    'issued-loan.label.currency_monthly_payment_in_cents': 'Monthly Payment',

    'issued-loan.label.status': 'Status',
    'issued-loan.label.void_reason': 'Reason for voiding loan',
    'issued-loan.label.rollback_reason': 'Reason for rolling back loan',

    'issued-loan.sort.field_label': 'Field',
    'issued-loan.sort.direction_label': 'Direction',
    'issued-loan.sort.direction_ascending': 'Ascending',
    'issued-loan.sort.direction_descending': 'Descending',

    'issued-loan.modal.title.issued_loan_repaid': 'Mark Repaid',
    'issued-loan.modal.title.issued_loan_rollback': 'Rollback Issued Loan',
    'issued-loan.modal.title.issued_loan_void': 'Void Issued Loan',
    'issued-loan.modal.title.issued_loan_restore': 'Restore Issued Loan',

    'issued-loan.modal.message.issued_loan_repaid': 'Are you sure that you want to mark this issued loan repaid? | Are you sure that you want to mark these issued loans repaid?',
    'issued-loan.modal.message.issued_loan_restore': 'Are you sure that you want to restore this issued loan? | Are you sure that you want to restore these issued loans?',
    'issued-loan.modal.message.issued_loan_rollback': 'This action will remove the associated bank transaction.',
    'issued-loan.modal.message.issued_loan_void': 'This action will create a bank transaction to show that the funds were returned.',

    'issued-loan.success.message.issued_loan_created': 'Your issued loan has been created',
    'issued-loan.success.message.issued_loan_updated': 'Your issued loan has been updated',
    'issued-loan.success.message.issued_loan_restored': 'Your issued loan has been restored | All selected issued loans were restored',
    'issued-loan.success.message.repaid_issued_loans': 'Your issued loan was marked repaid | All selected issued loans were marked repaid',
    'issued-loan.success.message.issued_loan_cancelled': 'Your draft loan has been cancelled.',
    'issued-loan.success.message.issued_loan_voided': 'Your loan has been voided.',
    'issued-loan.success.message.issued_loan_rolled_back': 'Your loan has been rolled back.',

    'issued-loan.error.message.repaid_issued_loans': 'This issued loan was already marked repaid | These issued loans were already marked repaid',
    'issued-loan.error.message.issued_loan_deleted': 'This issued loan was already permanently deleted | These issued loans were already permanently deleted',
    'issued-loan.error.message.issued_loan_restored': 'This issued loan was already restored | These issued loans were already restored',
    'issued-loan.error.message.error_loading_page': 'Sorry, there was an error loading issued loan.| Sorry, there was an error loading issued loans.',

    'issued-loan.message.search.no_repaid_issued_loans': "You don't have any repaid loans.",
};
